import { Peripherals } from 'entities/Peripherals/interfaces';
import { SecurityGate } from 'entities/SecurityGate/interfaces';
import {
  SET_DEP_TITLE,
  GET_SECURITY_GATE_REQUEST,
  GET_SECURITY_GATE_SUCCESS,
  GET_PERIPHERALS_REQUEST,
  GET_PERIPHERALS_SUCCESS,
  GET_SECURITY_GATE_ERROR,
  GET_PERIPHERALS_ERROR,
} from './constants';

export const getSecGateRequest = (params: any = {}) => ({
  type: GET_SECURITY_GATE_REQUEST,
  params,
});

export const getSecGateSuccess = (secGate: SecurityGate[]) => ({
  type: GET_SECURITY_GATE_SUCCESS,
  payload: secGate,
});

export const getSecGateError = (error: Error | null) => ({
  type: GET_SECURITY_GATE_ERROR,
  payload: error,
});

export const getPheripRequest = (sgid: string) => ({
  type: GET_PERIPHERALS_REQUEST,
  payload: sgid,
});

export const getPheripSuccess = (pherpherals: Peripherals[]) => ({
  type: GET_PERIPHERALS_SUCCESS,
  payload: pherpherals,
});

export const getPheripError = (error: Error | null) => ({
  type: GET_PERIPHERALS_ERROR,
  payload: error,
});

export const setDepTitle = (props: { name: string; id: string }) => ({
  type: SET_DEP_TITLE,
  payload: props,
});

export type Actions =
  | ReturnType<typeof getSecGateRequest>
  | ReturnType<typeof getSecGateSuccess>
  | ReturnType<typeof getSecGateError>
  | ReturnType<typeof getPheripRequest>
  | ReturnType<typeof getPheripError>
  | ReturnType<typeof getPheripSuccess>
  | ReturnType<typeof setDepTitle>;
